import { render, staticRenderFns } from "./ReportManageFormButtons.vue?vue&type=template&id=45231844&"
import script from "./ReportManageFormButtons.vue?vue&type=script&lang=js&"
export * from "./ReportManageFormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports